import React from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import MainTitle from "../../../components/ui/MainTitle";
import SubmitButton from "../../../components/form/SubmitButton";
import { useUpdateResource } from "../../../hooks/useUpdateResource";
import { useTranslation } from "react-i18next";
import LoadingButton from "../../../components/form/LoadingButton";
import CarBrandForm, { CarBrandFormData } from "../../../components/admin/carBrand/CarBrandForm";

export default function AdminAddCarBrandPage() {
  const navigate = useNavigate();

  const { register, handleSubmit, formState: { errors } } = useForm<CarBrandFormData>({
    defaultValues: {
      languages: [
        { languageCode: "en", title: "" },
        { languageCode: "ar", title: "" },
      ],
    },
  });

   const { t } = useTranslation();
  const { loading, updateResource } = useUpdateResource();

  const onSubmit = (data: CarBrandFormData) => {
    // call API to create category
    updateResource(`car-brand`, {languages:data.languages.map(da=> ({name:da.title , languageCode:da.languageCode}))},
        "admin",{
            method: "POST",
            successMessage: t("createdSuccess"),
            invalidateQueries:["car-brands-by-admin"],
            navigateAfter: () => navigate("/admin/car-brands"),
          });
  };

  return (
    <div className="p-6 container">
      <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-4 w-full">
        <MainTitle title="add_new_car_brand" />
        <CarBrandForm register={register} errors={errors} />
        {
        loading?
        <LoadingButton height={64}/> 
        :
        <SubmitButton height={64} label="create" />
        }
      </form>
    </div>
  );
}
